import { RoutingTypes } from '../consts';
import { NewRouteForm } from '../types';

export const getModelsArray = (data: NewRouteForm): string[] => {
  const models: string[] = [];
  if (data.ecmwf) {
    models.push(RoutingTypes['ecmwf-fc']);
  }
  if (data.gfs) {
    models.push(RoutingTypes['ncep-fc']);
  }
  if (data.ecmwfEnsemble) {
    models.push(RoutingTypes['ecmwf-eps']);
  }
  if (data.gfsEnsemble) {
    models.push(RoutingTypes['ncep-eps']);
  }
  if (data.aifsFc) {
    models.push(RoutingTypes['ecmwf-aifs-fc']);
    if (data.polarSpreadCalculation) {
      models.push(RoutingTypes['ecmwf-aifs-eff']);
    }
  }
  if (data.aifsEnemble) {
    models.push(RoutingTypes['ecmwf-aifs-eps']);
  }
  return models;
};
